import Logo from  './Logo';
import PizzaItems from './PizzaItems';
import './MenuPage.css'
import OtherItems from './otheritems/OtherItems';
import FriedItems from './FriedItems/FriedItems';

const MenuPage = () => {
    const otheritems = ["Wraps","Grill Sandwich","Burgers","PopCorns","French Fries","Biriyani","Mocktails"];
    return ( 
        <div className = "MenuPage_container">
           <Logo /><br/>
           <PizzaItems title="Veg Pizza"/><br/>
           <PizzaItems title="Non Veg Pizza"/><br/>
           {otheritems.map((title,index)=><OtherItems key={title} title={title}/>)}<br/>
           <FriedItems title="Fried Chicken"/><br/>
           <FriedItems title="Combos"/><br/>
           <OtherItems key={"Ice Creams"} title={"Ice Creams"}/>
          
           
        </div>
     );
}
 
export default MenuPage;